import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { PageArea } from './styled';
import Reveal from '../../components/Reveal';
import SmoothImage from '../../components/SmoothImage';

const historiaIlustrada = require('../../assets/images/historia-ilustrada.webp');
const familiaVinicius = require('../../assets/images/historia/familia-vinicius.webp');

const marcos = [
    {
        ano: '1721',
        foto: require('../../assets/images/historia/familia-martins-1954.webp'),
        legenda: 'Registro raro da família Martins (1954)',
        titulo: 'Uma das famílias mais antigas de Magé',
        texto: 'A família Martins de Oliveira tem seus primeiros registros no Brasil com o Sr. Manoel Martins de Oliveira, que recebeu da coroa portuguesa terras que iam do Rio Suruí até a região de Santo Aleixo.',
    },
    {
        ano: '1743',
        foto: require('../../assets/images/historia/capela-santo-aleixo.webp'),
        legenda: 'Capela de Santo Aleixo, em Magé',
        foto2: require('../../assets/images/historia/homenagem-capela.webp'),
        legenda2: 'Washington recebendo homenagem pelo livro Capela do Povo',
        titulo: 'A Capela de Santo Aleixo',
        texto: 'Em 4 de setembro de 1743 a família constrói a Capela de Santo Aleixo, onde até hoje se comemora a festa do santo. A escritura foi lavrada em 1747 e, no mesmo ano, a capela foi concluída e batizada.',
    },
    {
        ano: '1957',
        foto: require('../../assets/images/historia/fabrica-biscoitos.webp'),
        legenda: 'Uma das fábricas de biscoito do Sr. Manoel',
        titulo: 'Padarias e o ofício passado de geração em geração',
        texto: 'O Sr. Manoel Martins de Oliveira (9ª geração) foi vereador e mantinha uma padaria em Andorinhas, outra em Itaipava e uma fábrica de biscoitos em Guapimirim. Seu filho Washington trabalhou muito tempo na produção da padaria, e esse conhecimento o ajudou em toda a caminhada.',
    },
    {
        ano: '2007',
        titulo: 'Empreender está no sangue',
        texto: 'Washington Luis Martins de Oliveira e o filho mais velho, Victor Guimarães de Oliveira, começam os testes para a produção de salgados assados.',
    },
    {
        ano: '2011',
        foto: require('../../assets/images/historia/vinicius-washington.webp'),
        legenda: 'Vinícius (dono da Salato) e Washington',
        titulo: 'Nasce a Salato Alimentos',
        texto: 'Washington e o filho mais novo, Vinícius Guimarães de Oliveira, voltam a movimentar a empresa, agora com foco no bolinho de bacalhau. Com um pequeno espaço e alguns equipamentos cedidos pelo filho mais velho, montam a primeira estrutura de produção.',
    },
    {
        ano: '2014',
        foto: require('../../assets/images/historia/nossa-estrutura.webp'),
        legenda: 'Nossa estrutura de produção',
        titulo: 'A fábrica no Condomínio Unidas',
        texto: 'A Salato aluga um galpão no Condomínio Unidas, antiga fábrica de tecidos erguida em terras que pertenceram ao Sr. Manoel Martins de Oliveira. Um espaço bem mais amplo, com capacidade para produzir perto de mil quilos por dia.',
    },
    {
        ano: 'Hoje',
        foto: require('../../assets/images/historia/produto-mercado.webp'),
        legenda: 'Nossos produtos nas gôndolas dos mercados',
        titulo: 'Profissionalização e grandes parceiros',
        texto: 'Com formação em gastronomia e foco em qualidade, os produtos Salato estão em lugares como o Rio Sul Supermercados, Lanchonete Mariposa Galeão, Supermercados Maravista e entre outros.',
    },
];

const Page = () => {
    const [foto, setFoto] = useState(null);

    useEffect(() => {
        if (!foto) return undefined;
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        const onKey = (e) => e.key === 'Escape' && setFoto(null);
        window.addEventListener('keydown', onKey);
        return () => {
            document.body.style.overflow = prev;
            window.removeEventListener('keydown', onKey);
        };
    }, [foto]);

    return (
        <PageArea>
            {/* Linha do tempo */}
            <section className="timelineSection" aria-labelledby="linha-do-tempo">
                <Reveal className="sectionHeading">
                    <span className="sectionTag">Nossa história</span>
                    <h1 id="linha-do-tempo">Três séculos de família, alguns anos de Salato</h1>
                    <p>Um resumo de como chegamos até aqui.</p>
                </Reveal>

                <ol className="timeline">
                    {marcos.map((m, i) => (
                        <li key={m.ano} className={i % 2 ? 'right' : 'left'}>
                            <span className="dot" aria-hidden="true"></span>
                            <Reveal className="milestone" delay={60}>
                                <span className="year">{m.ano}</span>
                                <h3>{m.titulo}</h3>
                                <p>{m.texto}</p>
                                {m.foto && (
                                    <div className={`milestonePhotos${m.foto2 ? ' duo' : ''}`}>
                                        {[[m.foto, m.legenda], [m.foto2, m.legenda2]].filter(([src]) => src).map(([src, legenda]) => (
                                            <figure className="milestonePhoto" key={legenda}>
                                                <button type="button" onClick={() => setFoto({ src, legenda })} aria-label={`Ampliar foto: ${legenda}`}>
                                                    <SmoothImage src={src} alt={legenda} />
                                                    <span className="zoomHint" aria-hidden="true">⤢</span>
                                                </button>
                                                <figcaption>{legenda}</figcaption>
                                            </figure>
                                        ))}
                                    </div>
                                )}
                            </Reveal>
                        </li>
                    ))}
                </ol>

                <Reveal className="storyLink">
                    <button type="button" onClick={() => setFoto({ src: historiaIlustrada, legenda: 'História ilustrada da família Martins de Oliveira e da Salato', full: true })}>
                        Ver a história ilustrada completa <span aria-hidden="true">→</span>
                    </button>
                </Reveal>
            </section>

            {/* Família */}
            <section className="familySection">
                <Reveal className="familyPhoto">
                    <button type="button" onClick={() => setFoto({ src: familiaVinicius, legenda: 'A família do Vinícius, que fundou a Salato' })} aria-label="Ampliar foto da família do Vinícius">
                        <SmoothImage src={familiaVinicius} alt="A família do Vinícius, que fundou a Salato" width="803" height="688" />
                    </button>
                    <span className="photoLabel">O Homem que fundou, e a familia que cuida e fortelece a Salato.</span>
                </Reveal>
                <Reveal className="quote" delay={120}>
                    <span className="sectionTag">Nossos valores</span>
                    <blockquote>
                        “Deus em primeiro lugar, família, e amor ao próximo.”
                    </blockquote>
                    <cite>Vinícius Guimarães de Oliveira</cite>
                </Reveal>
            </section>

            {/* Hoje */}
            <Reveal className="todaySection">
                <span className="sectionTag">Hoje</span>
                <h2>Duas gerações, o mesmo propósito</h2>
                <p>
                    Hoje, Vinícius e seu filho mais velho, Lucas Mello, trabalham juntos em prol
                    do sucesso e da excelência da Salato.
                </p>
            </Reveal>

            {/* Chamada final */}
            <Reveal className="aboutCta">
                <div>
                    <h2>Faça parte dessa história</h2>
                    <p>Conheça nossos produtos ou fale com o nosso time comercial.</p>
                </div>
                <div className="ctaActions">
                    <Link to="/produtos" className="ctaPrimary">Ver produtos</Link>
                    <Link to="/contato" className="ctaGhost">Falar com a Salato</Link>
                </div>
            </Reveal>

            {foto && (
                <div className="storyModal" role="dialog" aria-modal="true" aria-label={foto.legenda}>
                    <div className="storyBackdrop" onClick={() => setFoto(null)} />
                    <figure className={`storyPanel${foto.full ? ' full' : ''}`}>
                        <button type="button" className="storyClose" onClick={() => setFoto(null)} aria-label="Fechar">×</button>
                        <img src={foto.src} alt={foto.legenda} />
                        {!foto.full && <figcaption>{foto.legenda}</figcaption>}
                    </figure>
                </div>
            )}
        </PageArea>
    );
};

const mapStateToProps = (state) => ({
    nome: state.user.nome,
});

const mapDispatchToProps = (dispatch) => ({
    setNome: (nome) => dispatch({ type: 'SET_NOME', payload: { nome } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page);
